import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerPWA } from "@/lib/pwa";
import { initializeGA4 } from "@/lib/analytics";

// Stale deployment guard: when Vite can't fetch a lazy chunk (because a new
// deploy replaced the hashed file), reload once to pick up fresh assets.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(<App />);

window.addEventListener("load", () => {
  initializeGA4();
  registerPWA();
});
